import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useUploadFileMutation, useUploadProfilePictureMutation } from "../../../../services/EndPointsApis";
import DateComp from "../../../../core/common/dateComponent/DateComp";

interface Folder {
  folderId: number;
  entityName: string;
  parentId: number | null;
  isFile: boolean;
  children: Folder[];
  isLocked: number;
}

const FolderGridView = React.memo(({ folders, setIsFile, viewFilePerm, editFilePerm, projectId, setSelectedParentId, setSelectedRowId, setSelectedFolderName }: any) => {
  const [selectedFolderPath, setSelectedFolderPath] = useState<string | null>(null);

  const handleFolderSelection = (path: string, folderId: any, parentId: any, folderName: any, isLocked: boolean, isFile: any) => {
    if (isLocked) return;
    setSelectedFolderPath(path);
    setSelectedRowId(folderId);
    setSelectedFolderName(folderName)
    setSelectedParentId(parentId)
    setIsFile(isFile)
  };

  const flattenFolders = (folder: Folder, parentPath: string = ""): any[] => {
    const currentPath = parentPath ? `${parentPath}` : `${folder.folderId}`;
    const flattened = [{ ...folder, path: currentPath }];

    if (!folder.isFile && folder.children.length > 0) {
      folder.children.forEach((child, index) => {
        const childPath = `${currentPath}.${index + 1}`;
        flattened.push(...flattenFolders(child, childPath));
      });
    }
    return flattened;
  };

  const flattenedFolders = folders?.result
    ?.map((folder: Folder, index: number) => flattenFolders(folder, `${index + 1}`))
    .flat() || []

  return (
    <div className="table-responsive mt-3" style={{ maxHeight: "540px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0", textAlign: "left", border: "1px solid #e3e2df" }}>
            <th style={{ padding: "8px" }}>File/Folder Name</th>
            <th style={{ padding: "8px" }}>Type</th>
            <th style={{ padding: "8px" }}>Created</th>
          </tr>
        </thead>
        <tbody>
          {flattenedFolders.map((folder: any) => (
            <tr
              key={folder.folderId}
              style={{
                backgroundColor: selectedFolderPath === folder.path ? "#e6f7ff" : "transparent",
                cursor: "pointer",
                border: "1px solid #e3e2df",
                opacity: folder.isLocked ? 0.5 : 1,
              }}
              onClick={() => handleFolderSelection(folder.path, folder.folderId, folder.parentId, folder.entityName, folder.isLocked, folder.isFile)}
            >
              <td
                style={{
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  marginLeft: `${(folder.path.split(".").length - 1) * 20}px`,
                }}
              >
                <span style={{ marginRight: "8px" }}>
                  {folder.isFile ? "📄" : "📁"}
                </span>
                <div className="d-flex align-items-center justify-content-between w-100 ">
                  {folder.isFile ? (
                    <p className="mb-0"
                    >
                      {`${folder.entityName}`}
                    </p>
                  ) : (
                    <span>{`${folder.entityName}`}</span>
                  )}
                  <div className="d-flex gap-3">
                    {folder.isFile && folder.localPath !== null ? (
                      <>
                        {editFilePerm &&
                          <button className="btn btn-primary p-1">
                            <a
                              href={folder.localPath}
                              target="_blank"
                              className="text-light fs-12"
                              rel="noopener noreferrer"

                            >
                              {/* {`${folder.entityName}`} */}
                              Edit File
                            </a>
                          </button>
                        }
                      </>
                    ) :
                      (
                        ""
                      )

                    }

                    {folder.isFile ? (
                      <>
                        {viewFilePerm &&
                          <button className="btn btn-primary p-1" onClick={() => {
                            window.open(folder.entityPath, '_blank', 'noopener,noreferrer');
                          }}>
                            <a
                              href={folder.entityPath}
                              target="_blank"
                              className="text-light fs-12"
                              rel="noopener noreferrer"
                            >
                              View File
                            </a>
                          </button>
                        }
                      </>
                    ) :
                      (
                        ""
                      )

                    }

                  </div>
                </div>
              </td>
              <td style={{ padding: "8px" }}>
                {folder.isFile ? "File" : "Folder"}
              </td>
              <td style={{ padding: "8px" }}>
                <DateComp formattedDate={folder.createdDate} />

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default FolderGridView;
